<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  isHeading: {
    type: Boolean,
    default: true,
    required: false
  },
  note: {
    type: String,
    default: '',
    required: false
  },
  buttonText: {
    type: String,
    default: 'もっと見る',
    required: false
  },
  buttonDir: {
    type: String,
    default: 'left',
    required: false
  },
  buttonCol: {
    type: String,
    default: 'white',
    required: false
  },
  buttonLink: {
    type: String,
    default: '',
    required: false
  },
  text: {
    type: String,
    default: '',
    required: false
  },
  buttonIcon: {
    type: String,
    default: '',
    required: false
  },
  placeholder: {
    type: String,
    default: '',
    required: false
  },
  sun: {
    type: Object,
    required: false
  },
  type: {
    type: String,
    default: '',
    required: false
  }
})
</script>

<template>
  <div class="sectiontitle">
    <div class="inner">
      <component
        :is="isHeading ? 'h2' : 'div'"
        class="title"
      >
        {{ title }}<span
          v-if="note"
          class="note"
        >{{ note }}</span>
      </component>
      <div
        v-if="buttonLink"
        class="button"
      >
        <CommonMoreButton
          :text="buttonText"
          :direction="buttonDir"
          :col="buttonCol"
          :link="buttonLink"
          :type="type"
        />
      </div>
      <div
        v-if="sun"
        class="sun"
      >
        <p class="time">
          {{ sun.time }}
        </p>
        <div class="sunrise">
          <p>(</p>
          <p>{{ sun.sunrise }}</p>
        </div>
        <div class="sunset">
          <p>{{ sun.sunset }}</p>
          <p>)</p>
        </div>
      </div>
    </div>
    <div
      v-if="text"
      class="sub"
    >
      <p class="text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sectiontitle {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .inner {
    gap: 6px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    flex: 1;
    gap: 5px;
    color: #101010;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    overflow-x: scroll;
    white-space: nowrap;
    &:has(+ .button) {
      &::after {
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        height: 100%;
        background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
        content: '';
        z-index: 10;
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .note {
    color: #ccc;
    font-size: 12px;
    line-height: 12px;
  }
  .button {
    display: flex;
    justify-content: flex-end;
  }
  .sub {
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: space-between;
    line-height: 100%;
    .text {
      color: #606060;
      font-size: 14px;
      line-height: 14px;
      text-align: right;
      font-weight: 600;
    }
  }
  .sun {
    display: flex;
    align-items: center;
    gap: 5px;
    .time {
      color: #606060;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
    }
    .sunrise,
    .sunset {
      display: flex;
      align-items: center;
      p {
        color: #606060;
        font-size: 14px;
        font-weight: 300;
        line-height: 1em;
      }
    }
    .sunset {
      p:first-child {
        padding-left: 14px;
        background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_sunset.svg');
        background-position: left center;
        background-repeat: no-repeat;
        background-size: 12px;
      }
    }
    .sunrise {
      p:last-child {
        padding-left: 14px;
        background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_sunrise.svg');
        background-position: left center;
        background-repeat: no-repeat;
        background-size: 12px;
      }
    }
  }
}
main {
  @media screen and (min-width: 830px) {
    .sectiontitle {
      flex-direction: row;
      gap: 0;
      align-items: center;
      justify-content: space-between;
      .title {
        flex-direction: row;
        font-size: 22px;
        line-height: 22px;
        white-space: wrap;
        overflow-x: unset;
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
